export default __webpack_public_path__ + "static/media/bu-rifa.db33cea0.png";